// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CXnu","buttons":"styles_buttons__1k0Tx"};